import actionItems from "../../../project-review/actionItems";

export default function(){
    return loadActionItems();
}

const loadActionItems = () => {
    return new Promise((resolve, reject) => {
        let $actionItemContainer = $('#actionItemContainer');
        if($actionItemContainer.length) {
            $actionItemContainer.load("/Forms/ProjectReview/LoadActionItemGrid", function () {
                actionItems();
                resolve();
            })
        }else{
            resolve();
        }
    })
}